import { useState } from 'react';

export function useContractMode() {
  const [mode, setMode] = useState('producao');
  const [templateData, setTemplateData] = useState(null);
  const [dataSource, setDataSource] = useState('loading');

  return {
    mode, setMode,
    templateData, setTemplateData,
    dataSource, setDataSource,
  };
}
